import FolderSolidIcon from '@eduzz/houston-icons/FolderSolid';
import UploadIcon from '@eduzz/houston-icons/Upload';
import IconButton from '@eduzz/houston-ui/IconButton';
import Table from '@eduzz/houston-ui/Table';
import Typography from '@eduzz/houston-ui/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import chargebackService from 'v2/services/chargeback';

interface IProps {
  setModalVisible: (visible: boolean, invoiceId: number) => void;
}

const listStatus = {
  10: 'Aguardando Documentação',
  20: 'Em Análise',
  1: 'Em Processamento',
  3: 'Inibido com Sucesso',
  7: 'Aceito pela Operadora',
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
  status: {
    textTransform: 'uppercase',
  },
}));

const List = ({ setModalVisible }: IProps) => {
  const classes = useStyles({});

  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);
  const [data] = useObservable(() => chargebackService.getChargebacks(), []);

  const [pagination] = useObservable(() => chargebackService.getPaginationResponse(), []);

  const onChangeRowsPerPage = (per_page: number) => {
    chargebackService.setPagination({ ...pagination, ...{ per_page, current_page: 1 } });
    document.querySelector('#chargeback_table').scrollIntoView();
  };

  const onChangePage = (page: number) => {
    chargebackService.setPagination({ ...pagination, ...{ current_page: page } });
    document.querySelector('#chargeback_table').scrollIntoView();
  };

  return (
    <Table id='chargeback_table' total={pagination?.total_items || 0} loading={isLoading} className={classes.root}>
      <Table.Header>
        <Table.Column width={100}>Fatura</Table.Column>
        <Table.Column width={120}>Solicitado em</Table.Column>
        <Table.Column width={200}>Cliente</Table.Column>
        <Table.Column width={250}>Produto</Table.Column>
        <Table.Column width={200}>Afiliado</Table.Column>
        <Table.Column width={100} align='right'>
          Valor
        </Table.Column>
        <Table.Column width={95}>Limite</Table.Column>
        <Table.Column width={60} align='center'>
          Ações
        </Table.Column>
      </Table.Header>
      <Table.Body>
        {data?.map((chargeback, index) => (
          <Table.Row data={chargeback} key={chargeback.id} index={index}>
            <Table.Cell>
              <Typography size='xxs'>{chargeback.invoice ? chargeback.invoice.id : '-'}</Typography>
              <Typography className={classes.status} size='xxxs' weight='semibold'>
                {listStatus[chargeback.id]}
              </Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography>{!!chargeback.requested_at && moment(chargeback.requested_at).format('L')}</Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography size='xxs' weight='semibold'>
                {chargeback.customer?.name}
              </Typography>
              <Typography size='xxs'>{chargeback.customer?.email}</Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography>{chargeback.product?.title}</Typography>
            </Table.Cell>
            <Table.Cell>
              {chargeback.affiliate?.name ? (
                <>
                  <Typography size='xxs' weight='semibold'>
                    {chargeback.affiliate?.name || '-'}
                  </Typography>
                  <Typography size='xxs'>{chargeback.affiliate?.email || '-'}</Typography>
                </>
              ) : (
                '-'
              )}
            </Table.Cell>
            <Table.Cell align='right'>
              <Typography>
                <FormattedNumber value={chargeback.invoice ? chargeback.invoice.amount : 0} format='BRL' />
              </Typography>
            </Table.Cell>
            <Table.Cell>
              <Typography>{!!chargeback.limit_date && moment(chargeback.limit_date).format('L')}</Typography>
            </Table.Cell>
            <Table.Cell align='center'>
              {chargeback.showUploadButton &&
                (!chargeback.hasFiles ? (
                  <Tooltip title='Subir arquivo' placement='top'>
                    <IconButton onClick={() => setModalVisible(true, chargeback.invoice.id)}>
                      <UploadIcon />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title='Ver arquivos' placement='top'>
                    <ButtonBase onClick={() => setModalVisible(true, chargeback.invoice.id)}>
                      <FolderSolidIcon />
                    </ButtonBase>
                  </Tooltip>
                ))}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      {!isLoading && pagination && (
        <Table.Pagination
          onChangePage={onChangePage}
          perPage={pagination?.per_page}
          page={pagination?.current_page}
          onChangePerPage={onChangeRowsPerPage}
          optionsPerPage='10,20,50,100'
        />
      )}
    </Table>
  );
};
export default List;
